import React from "react";
import { Infobox } from "@flixbus/honeycomb-react";
import type { CalculationLifecycleErrorsProps } from "./CalculationLifecycleErrors.types";

const ErrorBox: React.FC<{ message: string }> = ({ message }) => (
  <div role="alert">
    <Infobox appearance="danger" small>
      {message}
    </Infobox>
  </div>
);

const CalculationLifecycleErrors: React.FC<CalculationLifecycleErrorsProps> = ({
  completeError,
  recalculateError,
}) => (
  <>
    {completeError && <ErrorBox message={completeError} />}
    {recalculateError && <ErrorBox message={recalculateError} />}
  </>
);

export default CalculationLifecycleErrors;
